import * as api from '../api';

// eslint-disable-next-line
export const postTemplateData = (args) => {
  const { siteId } = args.options;
  return api.callPost(`/manager/sites/${siteId}/template`, args);
};
